import { DEAL_PRIVILEGE, TABS } from '@constants/common.constants';

export default function Skeleton({ selectedTab, type }: { selectedTab: TABS; type: DEAL_PRIVILEGE }) {
	return (
		<div className='grid grid-cols-1 tablet:grid-cols-2 desktop:grid-cols-3 gap-4 tablet:gap-6 desktop:gap-y-4'>
			<SkeletonCard hideMobile={selectedTab === TABS.ALL} />
			<SkeletonCard hideMobile={selectedTab === TABS.ALL} />

			<SkeletonCard hideDesktop={selectedTab === TABS.ALL && type === DEAL_PRIVILEGE.PRIVILEGE} />
			<SkeletonCard hideDesktop={selectedTab === TABS.ALL && type === DEAL_PRIVILEGE.PRIVILEGE} />

			<SkeletonCard showDesktop={true} hideDesktop={selectedTab === TABS.ALL && type === DEAL_PRIVILEGE.PRIVILEGE} />
			<SkeletonCard showDesktop={true} hideDesktop={selectedTab === TABS.ALL && type === DEAL_PRIVILEGE.PRIVILEGE} />
		</div>
	);
}

interface SkeletonCardProps {
	hideMobile?: boolean;
	showDesktop?: boolean;
	hideDesktop?: boolean;
}

function SkeletonCard({ hideMobile = false, showDesktop = false, hideDesktop = false }: SkeletonCardProps) {
	return (
		<div
			className={`flex gap-4 bg-white px-6 py-4 rounded-lg ${hideMobile && 'hidden tablet:flex'} ${showDesktop && 'hidden desktop:flex'} ${
				hideDesktop && 'desktop:hidden'
			}`}>
			<div className='flex-none w-[120px] h-[120px] rounded-lg bg-blue-grey-lightest'></div>
			<div className='flex flex-col gap-2 grow'>
				<div className='bg-blue-grey-lightest w-1/2 h-[18px] rounded'></div>
				<div className='bg-blue-grey-lightest w-full h-4 rounded'></div>
				<div className='bg-blue-grey-lightest w-full h-4 rounded'></div>
				<div className='bg-blue-grey-lightest w-full h-4 rounded'></div>
			</div>
		</div>
	);
}
